export enum AiCreditTransactionTypeEnum {
  Debit = 'Debit',
  Grant = 'Grant',
  Adjustment = 'Adjustment',
  Purchase = 'Purchase',
}
